module.exports = __webpack_public_path__ + "static/media/add-green.305ebe2b.svg";